function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5673,-719)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.666906,-1.63919e-17,-1.63919e-17,0.533056,-653.421,-1736.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2980.18,4629.84L2996.8,4610.73L3013.43,4629.84",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.34px"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white_arrow.4caea30e764295682dbc8873ca6ccc00.svg";